import React from 'react';

interface TypingPerson {
  employeeId: string;
  firstName: string;
  lastName: string;
}

interface TypingIndicatorProps {
  people: TypingPerson[];
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ people }) => {
  if (people.length === 0) return null;

  let text: string;
  if (people.length === 1) {
    text = `${people[0].firstName} pisze`;
  } else if (people.length === 2) {
    text = `${people[0].firstName} i ${people[1].firstName} piszą`;
  } else {
    text = `${people.length} osób pisze`;
  }

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground italic py-2 px-1">
      <span>{text}</span>
      <span className="inline-flex gap-0.5">
        <span className="w-1 h-1 bg-muted-foreground rounded-full animate-bounce [animation-delay:-0.3s]" />
        <span className="w-1 h-1 bg-muted-foreground rounded-full animate-bounce [animation-delay:-0.15s]" />
        <span className="w-1 h-1 bg-muted-foreground rounded-full animate-bounce" />
      </span>
    </div>
  );
};
